export default {
  auth: {
    // Compartidas
    email: "Email",
    password: "Contraseña",
    copyright: "© 2026 · Haltrix Partners",
    backToLogin: "← Volver al login",
    resetTitle: "Restablecer contraseña",
    unknownError: "Error desconocido",
    pwdMismatch: "Las contraseñas no coinciden",

    // Login
    taglineLine1: "Monitorización inteligente",
    taglineLine2: "del mercado farmacéutico",
    subtitle: "Accede con tus credenciales corporativas",
    emailPlaceholder: "usuario@helixscan.es",
    showPassword: "Mostrar contraseña",
    hidePassword: "Ocultar contraseña",
    forgotPassword: "¿Olvidaste tu contraseña?",
    verifying: "Verificando…",
    signIn: "Iniciar sesión",
    wrongCredentials: "Credenciales incorrectas",
    wrong2faCode: "Código de verificación incorrecto",
    twoFactorTitle: "Verificación en dos pasos",
    twoFactorDesc: "Introduce el código de 6 dígitos de tu app de autenticación (o un código de respaldo).",
    verify: "Verificar",
    back: "← Volver",
    enrollTitle: "Configura la verificación en dos pasos",
    enrollDesc: "Tu organización requiere 2FA. Configúralo una vez para continuar.",

    // Recuperar contraseña
    forgotDesc: "Introduce tu email y te enviaremos un enlace para elegir una nueva contraseña.",
    forgotEmailPlaceholder: "tu@empresa.es",
    forgotError: "No se pudo procesar la solicitud. Inténtalo de nuevo.",
    sending: "Enviando…",
    sendLink: "Enviar enlace",
    checkEmail: "Revisa tu email",
    sentTextPre: "Si",
    sentTextPost: "está registrado, recibirás un enlace para restablecer tu contraseña en los próximos minutos.",
    linkExpires: "El enlace expira en 15 minutos. Revisa también la carpeta de spam.",

    // Restablecer contraseña
    pwdTooShort: "La contraseña debe tener al menos 8 caracteres",
    linkInvalidExpired: "El enlace es inválido o ha expirado",
    linkInvalid: "Enlace inválido o incompleto.",
    backToLoginPlain: "Volver al login",
    greeting: "Hola, {name} 👋",
    resetDesc: "Elige una contraseña segura de al menos 8 caracteres.",
    newPassword: "Nueva contraseña",
    newPasswordPlaceholder: "Mínimo 8 caracteres",
    confirmPassword: "Confirmar contraseña",
    confirmPasswordPlaceholder: "Repite la contraseña",
    pwdUpdatedTitle: "Contraseña actualizada",
    pwdUpdatedText1: "Tu contraseña se ha cambiado correctamente.",
    pwdUpdatedText2: "Redirigiendo al login en unos segundos…",
    goToLoginNow: "Ir al login ahora",
    saving: "Guardando…",
    saveNewPassword: "Guardar nueva contraseña",
  },
};
